import { restApi } from "../restApi";
import { DEFAULT_API_PAYLOAD } from "~/lib/constants";
const version = "1";

export const registersApi = restApi.injectEndpoints({
  endpoints: (builder) => ({
    // Risk Register Control
    getRiskRegisterControls: builder.query<
      any,
      {
        "App-Name"?: string;
        pageNumber?: number;
        pageSize?: number;
        searchTerm?: string;
      }
    >({
      query: (queryArg = {}) => ({
        url: `/api/v${version}/risk-register-control`,
        params: {
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          searchTerm: queryArg.searchTerm,
        },
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      providesTags: ["RiskRegisterControl" as any],
    }),
    getRiskRegisterControl: builder.query<
      any,
      { id: string; "App-Name"?: string }
    >({
      query: (queryArg) => ({
        url: `/api/v${version}/risk-register-control/${queryArg.id}`,
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      providesTags: ["RiskRegisterControl" as any],
    }),
    createRiskRegisterControl: builder.mutation<
      any,
      { body: any; "App-Name"?: string }
    >({
      query: (queryArg) => ({
        url: `/api/v${version}/risk-register-control`,
        method: "POST",
        body: queryArg.body,
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      invalidatesTags: ["RiskRegisterControl" as any],
    }),
    updateRiskRegisterControl: builder.mutation<
      any,
      { id: string; body: any; "App-Name"?: string }
    >({
      query: (queryArg) => ({
        url: `/api/v${version}/risk-register-control/${queryArg.id}`,
        method: "PUT",
        body: queryArg.body,
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      invalidatesTags: ["RiskRegisterControl" as any],
    }),
    deleteRiskRegisterControl: builder.mutation<
      any,
      { id: string; "App-Name"?: string }
    >({
      query: (queryArg) => ({
        url: `/api/v${version}/risk-register-control/${queryArg.id}`,
        method: "DELETE",
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      invalidatesTags: ["RiskRegisterControl" as any],
    }),

    // Risk Register Entry
    getRiskRegisterEntries: builder.query<
      any,
      {
        "App-Name"?: string;
        pageNumber?: number;
        pageSize?: number;
        searchTerm?: string;
      }
    >({
      query: (queryArg = {}) => ({
        url: `/api/v${version}/risk-register-entry`,
        params: {
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          searchTerm: queryArg.searchTerm,
        },
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      providesTags: ["RiskRegisterEntry" as any],
    }),
    getRiskRegisterEntry: builder.query<
      any,
      { id: string; "App-Name"?: string }
    >({
      query: (queryArg) => ({
        url: `/api/v${version}/risk-register-entry/${queryArg.id}`,
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      providesTags: ["RiskRegisterEntry" as any],
    }),
    createRiskRegisterEntry: builder.mutation<
      any,
      { body: any; "App-Name"?: string }
    >({
      query: (queryArg) => ({
        url: `/api/v${version}/risk-register-entry`,
        method: "POST",
        body: queryArg.body,
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      invalidatesTags: ["RiskRegisterEntry" as any],
    }),
    updateRiskRegisterEntry: builder.mutation<
      any,
      { id: string; body: any; "App-Name"?: string }
    >({
      query: (queryArg) => ({
        url: `/api/v${version}/risk-register-entry/${queryArg.id}`,
        method: "PUT",
        body: queryArg.body,
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      invalidatesTags: ["RiskRegisterEntry" as any],
    }),
    deleteRiskRegisterEntry: builder.mutation<
      any,
      { id: string; "App-Name"?: string }
    >({
      query: (queryArg) => ({
        url: `/api/v${version}/risk-register-entry/${queryArg.id}`,
        method: "DELETE",
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      invalidatesTags: ["RiskRegisterEntry" as any],
    }),

    // Chemical Register Entry
    getChemicalRegisterEntries: builder.query<
      any,
      {
        "App-Name"?: string;
        pageNumber?: number;
        pageSize?: number;
        searchTerm?: string;
      }
    >({
      query: (queryArg = {}) => ({
        url: `/api/v${version}/chemical-register-entry`,
        params: {
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          searchTerm: queryArg.searchTerm,
        },
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      providesTags: ["ChemicalRegisterEntry" as any],
    }),
    getChemicalRegisterEntry: builder.query<
      any,
      { id: string; "App-Name"?: string }
    >({
      query: (queryArg) => ({
        url: `/api/v${version}/chemical-register-entry/${queryArg.id}`,
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      providesTags: ["ChemicalRegisterEntry" as any],
    }),
    createChemicalRegisterEntry: builder.mutation<
      any,
      { body: any; "App-Name"?: string }
    >({
      query: (queryArg) => ({
        url: `/api/v${version}/chemical-register-entry`,
        method: "POST",
        body: queryArg.body,
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      invalidatesTags: ["ChemicalRegisterEntry" as any],
    }),
    updateChemicalRegisterEntry: builder.mutation<
      any,
      { id: string; body: any; "App-Name"?: string }
    >({
      query: (queryArg) => ({
        url: `/api/v${version}/chemical-register-entry/${queryArg.id}`,
        method: "PUT",
        body: queryArg.body,
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      invalidatesTags: ["ChemicalRegisterEntry" as any],
    }),
    deleteChemicalRegisterEntry: builder.mutation<
      any,
      { id: string; "App-Name"?: string }
    >({
      query: (queryArg) => ({
        url: `/api/v${version}/chemical-register-entry/${queryArg.id}`,
        method: "DELETE",
        headers: {
          "App-Name": queryArg["App-Name"] || DEFAULT_API_PAYLOAD["App-Name"],
        },
      }),
      invalidatesTags: ["ChemicalRegisterEntry" as any],
    }),
  }),
});

export const {
  useGetRiskRegisterControlsQuery,
  useGetRiskRegisterControlQuery,
  useCreateRiskRegisterControlMutation,
  useUpdateRiskRegisterControlMutation,
  useDeleteRiskRegisterControlMutation,

  useGetRiskRegisterEntriesQuery,
  useGetRiskRegisterEntryQuery,
  useCreateRiskRegisterEntryMutation,
  useUpdateRiskRegisterEntryMutation,
  useDeleteRiskRegisterEntryMutation,

  useGetChemicalRegisterEntriesQuery,
  useGetChemicalRegisterEntryQuery,
  useCreateChemicalRegisterEntryMutation,
  useUpdateChemicalRegisterEntryMutation,
  useDeleteChemicalRegisterEntryMutation,
} = registersApi;
